export const AADHAAR_ALREADY_MASKED_REGEX = /x/i;
export const AADHAAR_NON_DIGIT_REGEX = /\D/g;
export const AADHAAR_MASKED_PREFIX = "XXXX XXXX ";
export const AADHAAR_NUMBER_LABEL = "Aadhaar Number";

export const ABSOLUTE_URL_REGEX = /^https?:\/\//i;
export const AMAZONAWS_HOSTNAME_FRAGMENT = "amazonaws.com";
export const LEADING_SLASHES_REGEX = /^\/+/;
export const DEFAULT_DOWNLOAD_FILE_NAME = "download.pdf";
export const MIN_DOWNLOAD_FILE_NAME_LENGTH = 10;

export const CONTRACT_SOURCE = {
  SIGNED_CONTRACT_PDF: "signed_contract_pdf",
  CONTRACT_SIGNED_URL: "contract_signed_url",
};

export const CONTRACT_COLUMN = {
  FIELD: "signed_contract_pdf",
  HEADER: "Kyc Contract",
  VIEW_CONTRACT: "View Contract",
  EMPTY_VALUE: "N/A",
  WIDTH: "160px",
};
